module.exports = "/static/assets/1e9652bec24bcaacf5285be19746a750.svg";